module.exports = __webpack_public_path__ + "static/new_filters-036d66801d3da04dd5e492a22c187e51.png";